import React from 'react';
import { FormattedMessage } from 'react-intl';

import Messages from '../../constants/messages';
import CancelLink from '../LegalLinks/CancelLink';
import SubscriptionTermsLink from '../LegalLinks/SubscriptionTermsLink';
import TrialOfferTermsLink from '../LegalLinks/TrialOfferTermsLink';

const OnboardingDisclaimer = props => {
  const translationValues = {
    cancel: <CancelLink />,
    subscriptionTerms: <SubscriptionTermsLink />,
    offerTerms: <TrialOfferTermsLink />,
  };

  return <FormattedMessage {...Messages.defaultDisclaimer} values={translationValues} />;
};

export default OnboardingDisclaimer;
